import { Col, Container } from "react-bootstrap";

function ad1() {
	return (
		<Container fluid className="my-4  py-5">
			<h4 className="text-capitalize  ">
				Follow us on Instagram for News, Offers & More
			</h4>
			<div className="horizontal-scroll text-center ">
				<div className=" horizontal-scroll">
					<Col>
						<img src="../../../static/images/Banners/insta/img1.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
					<Col>
						<img src="../../../static/images/Banners/insta/img2.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							As a gamer, superior sound counts for a lot. You need to hear
							enemies tiptoeing up behind you for a sneak attack or a slight
							change in the atmospheric music signaling a new challenge or
							task...
						</p>
					</Col>
					<Col>
						{" "}
						<img src="../../../static/images/Banners/insta/img3.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
					<Col>
						{" "}
						<img
							src="../../../static/images/Banners/insta/img4.jpg"
							alt="chapa"
							className=" bg-white rounded"
						/>{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
					<Col>
						{" "}
						<img src="../../../static/images/Banners/insta/img5.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
					<Col>
						<img src="../../../static/images/Banners/insta/img6.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
					<Col>
						<img src="../../../static/images/Banners/insta/img7.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
					<Col>
						<img src="../../../static/images/Banners/insta/img9.jpg" alt="chapa" />{" "}
						<p className="fs-6 text-black ">
							If you’ve recently made a desktop PC or laptop purchase, you might
							want to consider adding peripherals to enhance your home office
							setup, your gaming rig, or your business workspace...
						</p>
					</Col>
				</div>
			</div>
		</Container>
	);
}

export default ad1;
